<template>
    <b-button variant="primary" @click.stop="confirmar()" v-if="mostrarBtn">
        <span> <i class="fa fa-thumbs-o-up"></i> Aceitar </span>
    </b-button>
</template>

<script>
import { consultoriaStatus } from '../../ConsultoriaStatus'

export default {
    props: {
        consultoria: {
            type: Object,
            default: () => ({})
        },

        services: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmar() {
            this.$swal({
                title: `Solicitação de Consultoria`,
                html: 'Confirma o ACEITE da solicitação de consultoria?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.aceitar()
                }
            })
        },

        aceitar() {
            this.$store.dispatch('addRequest')
            let aceiteDto = {
                consultoriaId: this.$route.params.consultoriaId
            }
            this.services.aceitar(aceiteDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Solicitação aceita com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterConsultoriaAtualizada')
                    } else {
                        this.$toast.error(
                            'Erro ao processar a solicitação!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        mostrarBtn() {
            return (
                this.$temAcesso('APPSE-FORN-CONS-01') &&
                this.consultoria.status ===
                    consultoriaStatus.AGUARDANDO_ACEITACAO_CREDENCIADA
            )
        }
    }
}
</script>
